import classNames from "classnames";
import { FunctionComponent, ReactElement } from "react";
import { setData } from "rivals/shared/utils/qa";
import styles from "./RadioCheckbox.module.scss";
import { OwnProps } from "./types";

const RadioCheckbox: FunctionComponent<OwnProps> = ({
  className = "",
  data = "",
  disabled = false,
  isChecked,
  label,
  labelClassName,
  name,
  onChange,
  type = "checkbox",
  value
}): ReactElement => {
  const wrapperClasses = classNames(styles.checkboxWrapper, className, {
    [styles.disabled]: disabled
  });
  const labelClasses = classNames(styles.labelClassName, labelClassName);
  const checkboxClasses = classNames({
    empty: !isChecked,
    filled: isChecked
  });

  return (
    <div className={wrapperClasses}>
      <label
        className={labelClasses}
        htmlFor={name}
        {...setData(data, "label")}
      >
        <input
          {...setData(data, "input")}
          autoComplete="off"
          checked={isChecked}
          className={checkboxClasses}
          name={name}
          onChange={!disabled ? onChange : (): void => {}}
          title={name}
          type={type}
          value={value}
          {...setData(data, "checkbox")}
        />
        {label}
      </label>
    </div>
  );
};

export default RadioCheckbox;
